// @flow
import React, { useContext } from 'react';
import styled from 'styled-components';
import StepComponent from 'components/shared/StepComponent';
import type Step from 'models/Step';
import { media } from 'styles/Mixins';
import * as Layout from 'styles/Layout';
import PaymentMethodStore from 'stores/PaymentMethodStore';
import HomeApplicationStore from 'stores/HomeApplicationStore';
import HomieContext from 'HomieContext';

type PropsType = {
  widthStepper?: boolean,
  selectedIndex: number,
  stepsData: Array<Step>,
  freeNavigation: boolean,
  isDisabled: boolean,
  onSetCurrentPosition: (value: any) => void,
  OptionSize?: number,
  parameterIndexStep?: number,
  id?: string,
  linkToInTabs: (value: any) => void,
  isFromExternalTenant?: boolean,
  isOnlyEditIncome: boolean,
  isCurrentUserOwner: boolean
};

const StepperContainer = styled(Layout.FlexRow)`
  min-height: 45px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: inherit;
  margin: 0 auto;
  justify-content: start;
  background: #fff;
  position: ${props => (props.isFromExternalTenant ? 'sticky' : 'fixed')};
  ${props => props.isFromExternalTenant && 'top: 55px;'}
  overflow-x: scroll;
  z-index: 5;
  ${media.md`
    width: ${props => (props.widthStepper ? '878px' : '1024px')};
    ${props => props.isFromExternalTenant && 'top: 60px;'}
    flex-wrap: wrap;
    justify-content: center;
    min-height: 45px;
    flex-wrap: wrap;
    margin: 0 auto;
    background: #fff;
    overflow-x: hidden;
    overflow: hidden !important;
  `}
`;

const StepperComponent = ({
  isDisabled = false,
  widthStepper = false,
  isFromExternalTenant = false,
  isOnlyEditIncome = false,
  selectedIndex,
  stepsData,
  freeNavigation,
  OptionSize = stepsData.length,
  parameterIndexStep,
  id,
  onSetCurrentPosition,
  linkToInTabs,
  isCurrentUserOwner
}: PropsType) => {
  const setCurrentPosition = (
    position: number,
    freeNavigation: boolean
  ): void => {
    if (freeNavigation) {
      onSetCurrentPosition(position);
    }
  };
  const { currentUser } = useContext(HomieContext);

  const isActive = (stepName: string, index: number): boolean => {
    if (isOnlyEditIncome) return stepName === 'Ingresos';
    return !isDisabled && index <= selectedIndex;
  };

  const isDisabledStep = (stepName: string, index: number): boolean => {
    if (isOnlyEditIncome) return stepName !== 'Ingresos';
    return index > selectedIndex;
  };

  const widthOption = 1024 / OptionSize;

  const isEditionDisabled = () => {
    const payment = PaymentMethodStore.payApplicationByMethod();
    const homeApplication = HomeApplicationStore.getHomeApplication();
    return (
      ((payment && payment.payment.paid_at) ||
        (homeApplication &&
          homeApplication.payment &&
          homeApplication.payment.paid_at)) &&
      !currentUser.isAdmin
    );
  };

  return (
    <StepperContainer
      id="scrollx"
      widthStepper={widthStepper}
      isFromExternalTenant={isFromExternalTenant}
    >
      {stepsData.map((step, index) => {
        return (
          <div
            key={index}
            onClick={() => setCurrentPosition(index, freeNavigation)}
          >
            <StepComponent
              widthOption={widthOption}
              step={step}
              isActive={isActive(step.name, index) && !isEditionDisabled()}
              isCurrent={index <= selectedIndex}
              disabledAction={
                isDisabledStep(step.name, index) || isEditionDisabled()
              }
              instep={parameterIndexStep === index}
              linkTo={index}
              id={id}
              linkToInTabs={linkToInTabs}
              optionSize={OptionSize}
            />
          </div>
        );
      })}
    </StepperContainer>
  );
};

export default StepperComponent;
